/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CriticalPopulationCreateRequest,
  CriticalPopulationDecisionRequest,
  CriticalPopulationDimensionDefinitionResponse,
  CriticalPopulationResponse,
  CriticalPopulationTitlePreviewRequest,
  CriticalPopulationTitlePreviewResponse,
  CriticalPopulationUpdateRequest,
  GetClientCriticalPopulationsParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getClientCriticalPopulationById = (
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/${id}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetClientCriticalPopulationByIdQueryKey = (
  oktaUserId: string,
  clientId: number,
  id: number
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/critical-populations/${id}`,
  ] as const;
};

export const getGetClientCriticalPopulationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalPopulationByIdQueryKey(oktaUserId, clientId, id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalPopulationById>>
  > = ({ signal }) =>
    getClientCriticalPopulationById(
      oktaUserId,
      clientId,
      id,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalPopulationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientCriticalPopulationById>>
>;
export type GetClientCriticalPopulationByIdQueryError = ErrorType<unknown>;

export function useGetClientCriticalPopulationById<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulationById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationById<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulationById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulationById<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalPopulationById<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientCriticalPopulationByIdQueryOptions(
    oktaUserId,
    clientId,
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateClientCriticalPopulation = (
  oktaUserId: string,
  clientId: number,
  id: number,
  criticalPopulationUpdateRequest: BodyType<CriticalPopulationUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: criticalPopulationUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateClientCriticalPopulationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientCriticalPopulation>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalPopulationUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalPopulationUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateClientCriticalPopulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientCriticalPopulation>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalPopulationUpdateRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return updateClientCriticalPopulation(
      oktaUserId,
      clientId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientCriticalPopulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientCriticalPopulation>>
>;
export type UpdateClientCriticalPopulationMutationBody =
  BodyType<CriticalPopulationUpdateRequest>;
export type UpdateClientCriticalPopulationMutationError = ErrorType<unknown>;

export const useUpdateClientCriticalPopulation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateClientCriticalPopulation>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<CriticalPopulationUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalPopulationUpdateRequest>;
  },
  TContext
> => {
  return useMutation(
    getUpdateClientCriticalPopulationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const deleteClientCriticalPopulation = (
  oktaUserId: string,
  clientId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteClientCriticalPopulationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientCriticalPopulation>>,
    TError,
    { oktaUserId: string; clientId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientCriticalPopulation>>,
  TError,
  { oktaUserId: string; clientId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteClientCriticalPopulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientCriticalPopulation>>,
    { oktaUserId: string; clientId: number; id: number }
  > = (props) => {
    const { oktaUserId, clientId, id } = props ?? {};

    return deleteClientCriticalPopulation(
      oktaUserId,
      clientId,
      id,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientCriticalPopulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientCriticalPopulation>>
>;

export type DeleteClientCriticalPopulationMutationError = ErrorType<unknown>;

export const useDeleteClientCriticalPopulation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClientCriticalPopulation>>,
      TError,
      { oktaUserId: string; clientId: number; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientCriticalPopulation>>,
  TError,
  { oktaUserId: string; clientId: number; id: number },
  TContext
> => {
  return useMutation(
    getDeleteClientCriticalPopulationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getClientCriticalPopulations = (
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationResponse[]>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetClientCriticalPopulationsQueryKey = (
  oktaUserId: string,
  clientId: number,
  params?: GetClientCriticalPopulationsParams
) => {
  return [
    `/api/${oktaUserId}/clients/${clientId}/critical-populations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCriticalPopulationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCriticalPopulations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClientCriticalPopulationsQueryKey(oktaUserId, clientId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClientCriticalPopulations>>
  > = ({ signal }) =>
    getClientCriticalPopulations(
      oktaUserId,
      clientId,
      params,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && clientId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCriticalPopulations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCriticalPopulationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientCriticalPopulations>>
>;
export type GetClientCriticalPopulationsQueryError = ErrorType<unknown>;

export function useGetClientCriticalPopulations<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulations>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulations<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCriticalPopulations>>,
          TError,
          Awaited<ReturnType<typeof getClientCriticalPopulations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClientCriticalPopulations<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClientCriticalPopulations<
  TData = Awaited<ReturnType<typeof getClientCriticalPopulations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  clientId: number,
  params: GetClientCriticalPopulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClientCriticalPopulations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClientCriticalPopulationsQueryOptions(
    oktaUserId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const createClientCriticalPopulation = (
  oktaUserId: string,
  clientId: number,
  criticalPopulationCreateRequest: BodyType<CriticalPopulationCreateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: criticalPopulationCreateRequest,
      signal,
    },
    options
  );
};

export const getCreateClientCriticalPopulationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientCriticalPopulation>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      data: BodyType<CriticalPopulationCreateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    data: BodyType<CriticalPopulationCreateRequest>;
  },
  TContext
> => {
  const mutationKey = ['createClientCriticalPopulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientCriticalPopulation>>,
    {
      oktaUserId: string;
      clientId: number;
      data: BodyType<CriticalPopulationCreateRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, data } = props ?? {};

    return createClientCriticalPopulation(
      oktaUserId,
      clientId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientCriticalPopulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientCriticalPopulation>>
>;
export type CreateClientCriticalPopulationMutationBody =
  BodyType<CriticalPopulationCreateRequest>;
export type CreateClientCriticalPopulationMutationError = ErrorType<unknown>;

export const useCreateClientCriticalPopulation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createClientCriticalPopulation>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        data: BodyType<CriticalPopulationCreateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    data: BodyType<CriticalPopulationCreateRequest>;
  },
  TContext
> => {
  return useMutation(
    getCreateClientCriticalPopulationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const decideClientCriticalPopulation = (
  oktaUserId: string,
  clientId: number,
  id: number,
  criticalPopulationDecisionRequest: BodyType<CriticalPopulationDecisionRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/${id}/decisions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: criticalPopulationDecisionRequest,
      signal,
    },
    options
  );
};

export const getDecideClientCriticalPopulationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideClientCriticalPopulation>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalPopulationDecisionRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decideClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalPopulationDecisionRequest>;
  },
  TContext
> => {
  const mutationKey = ['decideClientCriticalPopulation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decideClientCriticalPopulation>>,
    {
      oktaUserId: string;
      clientId: number;
      id: number;
      data: BodyType<CriticalPopulationDecisionRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, id, data } = props ?? {};

    return decideClientCriticalPopulation(
      oktaUserId,
      clientId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DecideClientCriticalPopulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof decideClientCriticalPopulation>>
>;
export type DecideClientCriticalPopulationMutationBody =
  BodyType<CriticalPopulationDecisionRequest>;
export type DecideClientCriticalPopulationMutationError = ErrorType<unknown>;

export const useDecideClientCriticalPopulation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof decideClientCriticalPopulation>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        id: number;
        data: BodyType<CriticalPopulationDecisionRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof decideClientCriticalPopulation>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    id: number;
    data: BodyType<CriticalPopulationDecisionRequest>;
  },
  TContext
> => {
  return useMutation(
    getDecideClientCriticalPopulationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const previewClientCriticalPopulationTitle = (
  oktaUserId: string,
  clientId: number,
  criticalPopulationTitlePreviewRequest: BodyType<CriticalPopulationTitlePreviewRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationTitlePreviewResponse>(
    {
      url: `/api/${oktaUserId}/clients/${clientId}/critical-populations/title-preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: criticalPopulationTitlePreviewRequest,
      signal,
    },
    options
  );
};

export const getPreviewClientCriticalPopulationTitleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>,
    TError,
    {
      oktaUserId: string;
      clientId: number;
      data: BodyType<CriticalPopulationTitlePreviewRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    data: BodyType<CriticalPopulationTitlePreviewRequest>;
  },
  TContext
> => {
  const mutationKey = ['previewClientCriticalPopulationTitle'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>,
    {
      oktaUserId: string;
      clientId: number;
      data: BodyType<CriticalPopulationTitlePreviewRequest>;
    }
  > = (props) => {
    const { oktaUserId, clientId, data } = props ?? {};

    return previewClientCriticalPopulationTitle(
      oktaUserId,
      clientId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewClientCriticalPopulationTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>
>;
export type PreviewClientCriticalPopulationTitleMutationBody =
  BodyType<CriticalPopulationTitlePreviewRequest>;
export type PreviewClientCriticalPopulationTitleMutationError =
  ErrorType<unknown>;

export const usePreviewClientCriticalPopulationTitle = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>,
      TError,
      {
        oktaUserId: string;
        clientId: number;
        data: BodyType<CriticalPopulationTitlePreviewRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewClientCriticalPopulationTitle>>,
  TError,
  {
    oktaUserId: string;
    clientId: number;
    data: BodyType<CriticalPopulationTitlePreviewRequest>;
  },
  TContext
> => {
  return useMutation(
    getPreviewClientCriticalPopulationTitleMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getCriticalPopulationDimensions = (
  oktaUserId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CriticalPopulationDimensionDefinitionResponse[]>(
    {
      url: `/api/${oktaUserId}/critical-population-dimensions`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetCriticalPopulationDimensionsQueryKey = (
  oktaUserId: string
) => {
  return [`/api/${oktaUserId}/critical-population-dimensions`] as const;
};

export const getGetCriticalPopulationDimensionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCriticalPopulationDimensionsQueryKey(oktaUserId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCriticalPopulationDimensions>>
  > = ({ signal }) =>
    getCriticalPopulationDimensions(oktaUserId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oktaUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCriticalPopulationDimensionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCriticalPopulationDimensions>>
>;
export type GetCriticalPopulationDimensionsQueryError = ErrorType<unknown>;

export function useGetCriticalPopulationDimensions<
  TData = Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
          TError,
          Awaited<ReturnType<typeof getCriticalPopulationDimensions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalPopulationDimensions<
  TData = Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
          TError,
          Awaited<ReturnType<typeof getCriticalPopulationDimensions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCriticalPopulationDimensions<
  TData = Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCriticalPopulationDimensions<
  TData = Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCriticalPopulationDimensions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCriticalPopulationDimensionsQueryOptions(
    oktaUserId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
